import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, hasMany } from '@apexdesigner/schema-tools';

export const resourceCategory = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z.string().nullable().optional().describe('Name'),

    passCriteria: z.string().nullable().optional().describe('Pass Criteria'),

    sequence: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Sequence - Display order'),

    locked: z.boolean().nullable().optional().hidden().describe('locked'),

    resourceSetId: z.number().hidden().describe('Foreign key to ResourceSet'),

    items: hasMany('ResourceCategoryItem'),

    resourceSet: belongsTo('ResourceSet'),
  })
  .describe(
    'A named group of resources within a resource set, with its own pass criteria.',
  )
  .as('ResourceCategory');

export { resourceCategory as resourceCategorySchema };
